import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as d3Dsv from 'd3-dsv';
import $ from 'jquery';

import Autocomplete from '../autocomplete';
import Icon from '../Icon';

const { dsvFormat } = d3Dsv;
const csv = dsvFormat(';')

class CardSearch extends PureComponent {

  static propTypes = {
    renderCard: PropTypes.func,
    dataSource: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    notFoundMessage: PropTypes.string,
    showCloseButton: PropTypes.bool,
    data: PropTypes.object
  }

  static defaultProps = {
    renderCard: () => null,
    placeholder: '',
    notFoundMessage: 'Nichts gefunden ☹︎',
    showCloseButton: true,
    data: null
  }

  constructor() {
    super();

    this.state = {
      loading: true,
      data: [],
      selectedData: null
    };
  }

  componentDidMount() {
    if (this.props.data) {
      return this.setState({
        data, loading: false
      });
    }

    $.get(this.props.dataSource).done(res => {
      const data = csv.parse(res);
      this.setState({ data, loading: false });
    });
  }

  onSelect = (data) => {
    this.setState({ selectedData: data });
  }

  onClose = () => {
    this.setState({ selectedData: null });
    this.autocomplete.reset();
  }

  onPresetClick = (cityname) => {
    const data = this.state.data.find(d => d.Stadt === cityname);

    this.setState({ selectedData: data }, () => {
      this.autocomplete.search.refs.inputField.value = cityname;
    });
  }

  onReset = () => {
    this.setState({ selectedData: null });
  }

  render() {
    const showCloseButton = this.state.selectedData && this.props.showCloseButton;

    return (
      <div className="cardwidget">
        <div className="card-presets">
          <div className="card-presets__label">Beispiele:</div>
          {this.props.presets.map(p => (
            <div
              key={p}
              className="card-presets__item"
              onClick={() => this.onPresetClick(p)}
            >
              {p}
            </div>
          ))}
        </div>
        <Autocomplete
          placeholder={this.props.placeholder}
          fieldName={this.props.fieldName}
          data={this.state.data}
          onSelect={this.onSelect}
          selectedData={this.state.selectedData}
          notFoundMessage={this.props.notFoundMessage}
          ref={ref => { this.autocomplete = ref; }}
          reset={this.onReset}
        />
        {this.state.selectedData && (
          <div className="cardwidget__card">
            {showCloseButton &&
              <button className="btn close" onClick={this.onClose}>
                <Icon type="close" />
              </button>
            }
            {this.props.renderCard(this.state.selectedData)}
          </div>
        )}
      </div>
    )
  }

}

export default CardSearch;
